export default (senderId) => {
  const formatRegex = /^(02|0[0-9]{2})([0-9]{3,4})([0-9]{4})$|^(15..|16..|18..)([0-9]{4})$|^(0(?:3|5)0[0-9]?)([0-9]{3,4})([0-9]{4})$/
  const formatSenderId = String(senderId).match(formatRegex)
  const printSenderId = formatSenderId ? formatSenderId.filter((d, index) => index !== 0 && d).join('-') : senderId
  return printSenderId
}
